<template>
  <el-row class="g-header">
    <el-col :span="2">
      <div class="logo"><img src="../../../static/img/logo_gold.png" height="100%" style="vertical-align: top" /> </div>
    </el-col>

    <el-col :span="16">
      <ul class="menu">
        <li v-for="(item,index) in head_menu" :key='index'>
          <router-link v-if="!item.meta.hidden" tag='a' :to="item.path">{{item.meta.title}}</router-link>
        </li>
        <!-- <li>
          <router-link tag='a' :to="'/dashboard'">主界面</router-link>
        </li>
        <li>
          <router-link tag='a' :to="'/order'">投标订单</router-link>
        </li>
        <li>
          <router-link tag='a' :to="'/workerorder'">其他订单</router-link>
        </li>
        <li>
          <router-link tag='a' :to="'/user'">账户信息</router-link>
        </li>
        <li>
          <router-link tag='a' :to="'/companyInfo'">企业信息</router-link>
        </li>
        <li>
          <router-link tag='a' :to="'/faPiao'">发票信息</router-link>
        </li> -->

      </ul>
    </el-col>

    <el-col :span="4" :offset="1" class="user-info">
      <span class="user-name"><i class="iconfont el-icon-g-user"></i>{{username}}</span>
      <router-link tag='a' :to="'/login'">退出<i class="el-icon-right"></i></router-link>
    </el-col>
  </el-row>
</template>

<script>
import auth from '@/utils/auth'
import utils from '@/utils/utils'
import router from '@/router'
import Cookies from 'js-cookie'

export default {
  name: 'Header',
  data: function() {
    return {
      username: '',
      head_menu: []
    }
  },

  created() {
    this.username = auth.getusername()
    // console.log('router:', router.options.routes)
    this.head_menu = []
    if (router.options.routes && router.options.routes.length > 0) {
      for (var i = 0; i < router.options.routes.length; i++) {
        if (router.options.routes[i].name === 'home') {
          var routelist = []
          if (router.options.routes[i].children.length > 0) {
            router.options.routes[i].children.forEach(element => {
              // console.log('当前项目：' + JSON.stringify(element))
              if (
                element.path !== '/gongchengkuan' &&
                element.path !== '/hetonglvyue' &&
                element.path !== '/nongmingong' &&
                element.path !== '/yufukuan'
              ) {
                routelist.push(element)
              }
            })
          }
          this.head_menu = routelist
          break
        }
      }
    }
    // console.log('菜单:', JSON.stringify(this.head_menu))
  },
  mounted() {
    // const userInfo = Cookies.get('loginStatus')
    // if (userInfo == undefined || userInfo == null || userInfo == 0) {
    //   auth.removeToken()
    //   router.push('/login')
    // }

    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    window.addEventListener('unload', e => this.unloadHandler(e))
  },
  destroyed() {
    window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
    window.removeEventListener('unload', e => this.unloadHandler(e))
  },
  methods: {
    beforeunloadHandler() {
      this._beforeUnload_time = new Date().getTime()
    },
    unloadHandler(e) {
      this._gap_time = new Date().getTime() - this._beforeUnload_time
      //   debugger
      // 判断是窗口关闭还是刷新
      if (this._gap_time <= 5) {
        // 如巢是登录状态，关闭窗口前，移除用户
        Cookies.set('loginStatus', 0)
      }
    }
  }
}
</script>

<style>
.menu .router-link-active {
  font-weight: bold;
  color: #e3a720;
  border-bottom: 3px solid #e3a720;
}
</style>




// WEBPACK FOOTER //
// src/components/common/Header.vue